import ServiceBase from './serviceBase';
import {
  ActionPlanContextType,
  ActionPlanItemContextType,
  OperActionPlanItem,
  OperationActionPlanCreateDto,
  OperationActionPlanDocumentDto,
  OperationActionPlanItemRequestDto,
} from './types/ActionPlan';

class OperActionPlanService extends ServiceBase {
  getActionPlanContext = async (operationId: string): Promise<ActionPlanContextType> =>
    this.get<ActionPlanContextType>(`operationactionplan/${operationId}/actionplancontext`);

  getActionPlanItemContext = async (
    operationActionPlanId: string
  ): Promise<ActionPlanItemContextType> =>
    this.get<ActionPlanItemContextType>(
      `operationactionplan/${operationActionPlanId}/actionplanitemcontext`
    );

  getActionPlanItems = async (actionPlanId: number): Promise<OperActionPlanItem[]> =>
    this.get<OperActionPlanItem[]>(`operationactionplan/${actionPlanId}/actionplanitems`);

  saveActionPlan = async (payload: OperationActionPlanCreateDto): Promise<number> =>
    this.post<number>(`operationactionplan/create`, payload);

  saveActionPlanItem = async (payload: OperationActionPlanItemRequestDto): Promise<number> => {
    if (payload.id) {
      return this.put<number>(`operationactionplan/actionplanitem`, payload);
    }
    return this.post<number>(`operationactionplan/actionplanitem`, payload);
  };

  deleteActionPlanItem = async (actionPlanId: number, actionPlanItemId: number): Promise<void> =>
    this.delete<void>(`operationactionplan/${actionPlanId}/actionplanitem/${actionPlanItemId}`);

  deleteActionPlanDocument = async (actionPlanDocumentId: number): Promise<void> =>
    this.delete<void>(`operationactionplan/${actionPlanDocumentId}/actionplandocument`);

  uploadDocument = async (
    payload: OperationActionPlanItemRequestDto,
    formData: FormData
  ): Promise<void> => {
    const json = btoa(JSON.stringify(payload));
    formData.append('entity', json);
    await this.post<boolean>(`operationactionplan/document-upload`, formData);
  };

  getDocuments = async (actionPlanId: number): Promise<OperationActionPlanDocumentDto[]> => {
    const result = await this.get<OperationActionPlanDocumentDto[]>(
      `operationactionplandocuments/${actionPlanId}`
    );
    return result;
  };

  downloadDocument = async (actionPlanId: number): Promise<boolean> => {
    await this.download(`operationactionplan/${actionPlanId}/download`);
    return true;
  };

  deleteAP = async (actionPlanId: number): Promise<boolean> => {
    await this.delete(`operationactionplan/${actionPlanId}`);
    return true;
  };
}

const operActionPlanService = new OperActionPlanService();

export default operActionPlanService;
